const initialState = {
  isAuthenticated: false,
  appLoaded: false,
  email: '',
  profile: {},
  token: null,
};

function authReducer(state, action = {}) {
  const { email, type, token, profile } = action;

  switch (type) {
    case 'logout':
      return { ...initialState };
    case 'login':
      return { ...state, isAuthenticated: true, email, token };
    case 'setProfile':
      return { ...state, appLoaded: true, profile };
    default:
      return { ...state };
  }
}

export { initialState, authReducer };
